const availableLanguages = require('resources/languages.json');

export default `/:locale(${availableLanguages.join('|')})?`;
